import styled, { css } from "styled-components";
import { devices } from "@/constants/media";
import { ROOM_BUTTONS_HEIGHT, SIDEBAR_HEADER_HEIGHT } from "@/constants/ui";

const SIDEBAR_WIDTH = 404;
const MOBILE_TOP_OFFSET = 56;

export const StyledSidebar = styled.div<{
  $open: boolean;
  $height: number;
}>`
  background-color: var(--color-white);
  width: ${SIDEBAR_WIDTH}px;
  margin: var(--spacing-md) 0;
  transition: all var(--transition-fast);
  ${({ $open }) => $open ? css`
      margin-right: var(--spacing-md);
      opacity: 1;
    ` : css`
      margin-right: -${SIDEBAR_WIDTH}px;
      opacity: 0;
    `};
  border-radius: var(--radius-xl);
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 3;
  @media ${devices.md} {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
    margin: 0;
    width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: ${({ $height }) => `${$height - MOBILE_TOP_OFFSET}px`};

    ${({ $open }) => $open ? css`
      transform: translateY(0%);
      opacity: 1;
    ` : css`
      transform: translateY(100%);
      opacity: 0;
    `};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md);
  position: relative;
  border-bottom: 1px solid var(--color-border);
`;

export const StyledCloseButton = styled.button`
  background: transparent;
  border: none;
  padding: var(--spacing-xs);
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const StyledBody = styled.div<{
  $height: number;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: ${({ $height }) => `${$height - SIDEBAR_HEADER_HEIGHT - ROOM_BUTTONS_HEIGHT - 32}px`};
  @media ${devices.md} {
    max-height: ${({ $height }) => `${$height - SIDEBAR_HEADER_HEIGHT - MOBILE_TOP_OFFSET}px`};
  }
`;
